import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { SignLoanModal } from '../../../common/modals';
import { contractType } from '../../../common/enums';
import { connectModal } from '../../../features/modal/hoc';
import { selectData } from '../../../features/modal/ducks';
import { selectToken } from '../../../features/auth/ducks';
import { signLoanActions } from '../ducks';
import { apiCallIds } from '../api';
import { getFileUrl } from '../../../common/utils/helpers';

const mapStateToProps = state => ({
  loan: selectData(state, apiCallIds.SIGN_LOAN),
  token: selectToken(state),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      signLoan: signLoanActions.request,
    },
    dispatch
  ),
});

@connect(mapStateToProps, mapDispatchToProps)
@connectModal(apiCallIds.SIGN_LOAN)
export default class SignLoan extends Component {
  static propTypes = {
    modalActions: PropTypes.object.isRequired,
    isVisible: PropTypes.bool.isRequired,
    isLoading: PropTypes.bool.isRequired,
    actions: PropTypes.object.isRequired,
    loan: PropTypes.object,
    token: PropTypes.string.isRequired,
  };

  handleSubmit = () => {
    const { actions, loan } = this.props;
    actions.signLoan({ loanId: loan.id });
  };

  render() {
    const { isVisible, isLoading, modalActions, token, loan } = this.props;

    if (!isVisible && !loan) {
      return null;
    }

    const contract = loan.contracts.find(c => c.type === contractType.MANDATE);
    const insuranceContract = loan.contracts.find(c => c.type === contractType.INSURANCE_APPLICATION);

    let insuranceFileLocation = null;
    if (insuranceContract) {
      insuranceFileLocation = getFileUrl(insuranceContract.fileId, token)
    }

    if (!contract) {
      return null;
    }

    return (
      <SignLoanModal
        modalActions={modalActions}
        isLoading={isLoading}
        onSubmit={this.handleSubmit}
        fileLocation={getFileUrl(contract.fileId, token)}
        insuranceFileLocation={insuranceFileLocation}
        withInsurance={!!insuranceContract}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/loans/components/SignLoan.js